/** @jsxImportSource theme-ui @jsxRuntime classic */

import {
  Box,
  Container,
  Flex,
  Grid,
  Section,
  Text,
  TishmanThemeName,
  useBreakpointIndex,
  useThemeUI,
} from '@tishman/components';
import * as Icons from '@tishman/icons';
import React from 'react';

export interface ReviewProps {
  review: string;
  source: string;
}

interface TripAdvisorReviewsProps {
  reviews: ReviewProps[];
  theme: TishmanThemeName;
}

export const TripAdvisorReviews = ({
  reviews,
  theme,
}: TripAdvisorReviewsProps): React.JSX.Element => {
  const isMobile = useBreakpointIndex() < 2;
  const themeUI = useThemeUI();

  return (
    <Section theme={theme}>
      <Container paddingY={6}>
        <Flex
          sx={{
            alignItems: 'center',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'center',
            pb: 5,
          }}
        >
          <Icons.TripAdvisor style={{ marginRight: themeUI.theme.space[3] }} />
          <Text variant="smallTitle">Via TripAdvisor</Text>
        </Flex>
        <Grid columns={[1, 3]} gap={5}>
          {reviews &&
            reviews.map((t: ReviewProps, index: number) => (
              <Box bg="white" key={index} padding={4}>
                <Text color="#000" sx={{ fontWeight: 'medium' }}>
                  &ldquo;{t.review}&rdquo;
                </Text>
                <Text
                  color="black"
                  sx={{ fontWeight: 'bold', pt: 3 }}
                >{`- ${t.source}`}</Text>
              </Box>
            ))}
        </Grid>
      </Container>
    </Section>
  );
};
